module.exports = __webpack_public_path__ + "img/wechat-pay.78f927a6.svg";